function o(r, y, i = !1) {
  return y ? Object.keys(y).reduce(
    (n, f) => {
      const s = f, e = n[s], t = y[s];
      return e == null || i && e === "" || Array.isArray(e) && e.length === 0 ? n[s] = t : typeof e == "object" && typeof t == "object" && t !== null && !Array.isArray(e) && !Array.isArray(t) ? n[s] = o(
        e,
        t,
        i
      ) : Array.isArray(e) && Array.isArray(t) && (n[s] = [...t]), n;
    },
    { ...r }
  ) : r;
}
const u = () => {
}, A = (r) => r == null ? !0 : typeof r == "string" || Array.isArray(r) ? r.length === 0 : typeof r == "object" ? Object.keys(r).length === 0 : !1;
export {
  o as deepMergeObjects,
  A as isEmpty,
  u as noop
};
